import ChatWidget from "./ChatWidget";
import Footer from "./Footer";
import Header from "./Header";
import "./TermsConditions.css";
import { ThumbsUp } from "lucide-react";

const TermsConditions = () => {
  return (
    <>
    <Header />
      {/* Banner */}
      <section className="terms-hero">
        <h1>Terms & Conditions</h1>
         <p>
          Welcome to Tredixo. By accessing or using our website, content,
          communication channels, or educational services, you agree to the
          following Terms & Conditions.
        </p>
      </section>

      {/* Content */}
       <section className="terms-body">
        <h2>Important Trading Guidelines</h2>

        <p className="terms-intro">
          These terms are designed to ensure a fair, transparent, and secure
          trading environment for all users. We highly recommend that you read
          this document thoroughly before you begin trading on our platform.
        </p>

        {/* Prohibited Practices */}
        <div className="terms-item">
          <div className="terms-icon">
            <ThumbsUp size={28} />
          </div>

          <div className="terms-text">
            <h3>Prohibited Practices</h3>
            <p>
              The use of Chamka lines and insider trading is strictly prohibited.
              Any involvement in such activities will result in the suspension
              or deactivation of your account.
            </p>
          </div>
        </div>

        {/* Scalping Policy */}
        
          <div className="terms-item">
            <div className="terms-icon">
              <ThumbsUp size={28} />
            </div>

            <div className="terms-text">
              <h3>Scalping Policy</h3>
              <p>
                Scalping is not allowed. Scalping trades will be removed from the
                server to maintain fair trading conditions for all users.
              </p>
            </div>
          </div>

           <div className="terms-item">
            <div className="terms-icon">
              <ThumbsUp size={28} />
            </div>

            <div className="terms-text">
              <h3>Order Execution</h3>
              <p>
               Orders will be executed based on bid/ask prices, not the Last Traded Price (LTP). Please be aware that the execution might vary based on market conditions.
              </p>
            </div>
          </div>
           <div className="terms-item">
            <div className="terms-icon">
              <ThumbsUp size={28} />
            </div>

            <div className="terms-text">
              <h3>Technical Issues</h3>
              <p>
                In the event of technical issues or glitches, you must report them immediately along with your user ID within 10 minutes.
              </p>
            </div>
          </div>
           <div className="terms-item">
            <div className="terms-icon">
              <ThumbsUp size={28} />
            </div>

            <div className="terms-text">
              <h3>Hedging Policy</h3>
              <p>
               Hedging is not allowed on the Tredixo trading platform. Any attempt to hedge may result in account restrictions.
              </p>
            </div>
          </div>
           <div className="terms-item">
            <div className="terms-icon">
              <ThumbsUp size={28} />
            </div>

            <div className="terms-text">
              <h3>Invalid Orders</h3>
              <p>
                Buy stop or sell stop orders placed without an open position or exceeding existing position quantities are prohibited. These orders will not be processed.
              </p>
            </div>
          </div>
       
      </section>
       <section className="terms-hero">
        <h1>Margin Maintenance</h1>
         <p>
         You are required to ensure that your account maintains sufficient funds to avoid the liquidation of your positions. This is crucial for maintaining your trading account in good standing.
        </p>
      </section>
       <section className="terms-body">
        <h2>Important Notice</h2>
        <p>These terms and conditions are subject to change without prior notice. It is your responsibility to review them regularly. Continued use of our services constitutes acceptance of any modifications.</p>
       </section>
         <Footer />
             <ChatWidget />
    </>
  );
};

export default TermsConditions;
